module.exports = __webpack_public_path__ + "static/img/img1.a4c5bfb0.png";